<template>
  <div class="banner-loader">
    <vue-content-loading
      :width="width"
      :height="height">
      <rect
        x="0"
        y="0"
        rx="0"
        ry="0"
        width="100%"
        height="100%"/>
    </vue-content-loading>
  </div>
</template>
<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'BannerLoaderComponent',
  components: {
    VueContentLoading,
  },
  data() {
    return {
      dimensions: {
        1200: 385, 1024: 350, 768: 300, 576: 225,
      },
      height: 0,
      width: window.innerWidth,
    };
  },
  beforeMount() {
    /* eslint-disable */
    Object.keys(this.dimensions).forEach((item) => {
      if (this.currentScreenWidth >= item) {
        this.height = this.dimensions[item];
        return;
      }
    });
  },
};
</script>

<style lang="scss">
.banner-loader {
  margin: 16px 0;
}
</style>



// WEBPACK FOOTER //
// app/src/components/loaders/BannerLoader.vue